import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { LayoutGrid } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

export default function PortalSwitch() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();
  const portals = [];
  if ((user?.effective_permissions || []).length) portals.push({ to: "/admin", label: "Administration" });
  if ((user?.roles || []).includes("secretary")) portals.push({ to: "/secretaire", label: "Espace secrétaire" });
  portals.push({ to: "/espace", label: "Espace client" });
  if (portals.length < 2) return null;
  const current = portals.find((p) => loc.pathname.startsWith(p.to))?.label || "Espace";
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="hidden sm:flex items-center gap-1.5 h-9 px-3 rounded-lg border border-slate-200 bg-white hover:bg-slate-50 text-sm font-medium text-slate-600" data-testid="portal-switch">
          <LayoutGrid className="h-4 w-4" />{current}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {portals.map((p) => <DropdownMenuItem key={p.to} onClick={() => navigate(p.to)}>{p.label}</DropdownMenuItem>)}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
